const journal = {
	name: 'Buchungen',
	fields: {
		primanota: 'Primanota',
		booking_date: 'Buchungsdatum',
		// Kurzform nur fuer die Tabellenspalte (via `i18nKey`): 'Buchungsdatum'
		// ist ein unteilbares 101-px-Wort und zwang die Spalte auf 178 px,
		// obwohl das Datum selbst nur 71 px braucht.
		booking_date_short: 'Datum',
		contra_account_id: 'Gegenkonto',
		debit: 'Soll',
		credit: 'Haben',
		opening_balance: 'Vortrag',
		booking_text: 'Buchungstext',
		comments_count: 'Kommentare',
		document_container_id: 'Beleg',
		review_state: 'Geprüft',
	},
}

export default journal
